import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof geodata
 */
class DataReferenceResource extends ActiveRecord {
    get id() {
        return `${this.type}:${this.sourceId || ''}:${this.column}`;
    }
    initialize(props) {
        if ('id' in props) {
            delete props.id;
        }
        super.initialize(props);
    }
    toJSON() {
        return {
            id: this.id,
            type: this.type,
            sourceId: this.sourceId,
            column: this.column,
        };
    }
}
DataReferenceResource.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
    options: {
        responseRecordsPropertyName: 'results',
    },
};
export default DataReferenceResource;
